import { render, staticRenderFns } from "./YingTongDevice.vue?vue&type=template&id=8061a340&scoped=true&"
import script from "./YingTongDevice.vue?vue&type=script&lang=js&"
export * from "./YingTongDevice.vue?vue&type=script&lang=js&"
import style0 from "./YingTongDevice.vue?vue&type=style&index=0&id=8061a340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8061a340",
  null
  
)

export default component.exports